<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="soliloquy-of-love">
<h1>Soliloquy of Love</h1>
<p style="text-indent:0em">The time was drawing near, I sat by her bedside, no words were spoken, our eyes had met in the valley of love. I held her hand tightly, a sweet kiss on the lips, she was now entering uncharted waters, her eyes closed for the last time, as I watched a tear float from a closed eye. I whispered in her ear, I am with you, I felt her hand tightly grasping mine, moments later, her hand went limp and with her all my tomorrows had gone.</p><br/>
<p style="text-indent:0em">Tonight before bedtime, tell someone you love them.</p><br/>
<p style="text-indent:0em">We don’t cry because it’s over, we smile because it happened.</p><br/>
<p style="text-indent:0em">Dr. Suess.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?3f5fb2e0